/*********************************************
 * Adjust the height of the screen
 *********************************************/
const createEl = ({tag = 'div', className = ''}) => {
    const el = document.createElement(tag);

    if(className.length){
        el.classList.add(className);
    }

    return el;
};

const css = (el, prop, val) => typeof val !== 'undefined' ? el.style.setProperty(prop, val) : getComputedStyle(el).getPropertyValue(prop);
const getAddressBarHeight = () => {
    const pseudoDiv = createEl({tag: 'div', className: 'pseudo-address-bar-detector'});
    document.body.appendChild(pseudoDiv);

    Object.assign(pseudoDiv.style, {
        height: '100vh',
        width: 0,
        position: 'absolute',
        pointerEvents: 'none'
    });

    const actualHeight = window.innerHeight;
    const elementHeight = pseudoDiv.clientHeight;
    const barHeight = elementHeight - actualHeight;

    // remove from DOM
    pseudoDiv.remove();

    css(document.documentElement, '--sp-address-bar-height', `${barHeight}px`);
}
getAddressBarHeight();


/*********************************************
 * Init date picker
 *********************************************/
document.querySelectorAll('#date_of_birth, #newsletter_date_of_birth').forEach((input) => {
    datepicker(input, {
        formatter: (input, date, instance) => {
            input.value = date.toLocaleDateString() // => '1/1/2099'
        }
    })
})


/*********************************************
 * Show first item in tabs
 *********************************************/
window.addEventListener('DOMContentLoaded', () => {
    const tab = document.querySelectorAll('.product-section .collapsible')[0];
    if(tab){
        const tabButton = tab.querySelector('collapsible-button');
        if(tabButton) tabButton.click();
    }
});


/*********************************************
 * Hide branding button
 *********************************************/
document.querySelectorAll('.formful__wrapper').forEach((wrapper) => {
    const button = wrapper.querySelector('.formful__branding');
    if(button) button.remove();
});


/*********************************************
 * Add to cart
 *********************************************/
document.querySelectorAll('.btn.product--add-to-cart-button').forEach((button) => {
    // return if desktop
    if(window.innerWidth > 767) return;

    const spacingTopFromCartButton = button.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop || 0),
        spacingShowCartButton = Math.max(0, spacingTopFromCartButton - window.innerHeight);

    // return if sticky cart is not present
    const stickyCart = document.querySelector('.sp-sticky-cart');
    if(!stickyCart) return;

    const handleScroll = () => {
        if(window.pageYOffset > spacingShowCartButton + window.innerHeight / 2){
            document.querySelector('body').classList.add('show-add-to-cart');
        }else{
            document.querySelector('body').classList.remove('show-add-to-cart');
        }
    }

    handleScroll();
    window.addEventListener('scroll', () => handleScroll());

    stickyCart.addEventListener('click', () => {
        const info = document.querySelector('.grid.product-single .sp-product-info-mobile + .grid__item + product-information');
        if(info){
            window.scrollTo({
                top: info.getBoundingClientRect().top + window.scrollY,
                behavior: 'smooth'
            });
        }
    });

});


/*********************************************
 * Add ETA
 *********************************************/
window.addEventListener('load', () => {
    document.querySelectorAll('.sp-size-chart-tab').forEach((wrapper) => {
        wrapper.querySelectorAll('.sp-size-chart-tab__nav button').forEach((btn, i) => btn.setAttribute('data-eta-trigger', `tab-${i}`));
        wrapper.querySelectorAll('.sp-size-chart-tab__content > div').forEach((panel, i) => panel.setAttribute('data-eta-receiver', `tab-${i}`));

        ETA.init({ el: wrapper, activeSection: 0, animation: 'fade' });
    });
});


/*********************************************
 * change order button
 *********************************************/
document.querySelectorAll('[data-update-id*="item-out_of_stock"]').forEach((wrapper) => {
    const soldOutBtn = document.querySelector('[data-block-id="buy_buttons"]');

    if(soldOutBtn){
        //wrapper.parentElement.insertBefore(soldOutBtn, wrapper.nextSibling);
    }
});

document.querySelectorAll('.sp-product-info-mobile').forEach((wrapper) => {
    const slider = wrapper.parentElement.querySelector('.grid__item');

    if(slider){
        wrapper.parentElement.insertBefore(slider, wrapper.nextSibling);
    }
});


/*********************************************
 * Init easy popup
 *********************************************/
window.addEventListener('load', () => {
    document.querySelectorAll('.sp-size-chart-buttons').forEach((wrapper) => {
        const nextElement = wrapper.nextElementSibling;
        if(!nextElement) return;
        const id = nextElement.getAttribute('data-easy-popup');
        const button = wrapper.querySelector('.sp-size-chart-btn');
        button.setAttribute('data-ep-toggle', id);

        // click
        window.addEventListener('click', e => {
            const button = e.target.closest('.sp-size-chart-btn');

            if(button){
                const nextElement = wrapper.nextElementSibling;
                const id = nextElement.classList.contains('sp-size-chart-popup') ? nextElement.getAttribute('data-easy-popup') : button.getAttribute('href').substring(1);

                if(id){
                    setTimeout(() => {
                        const popup = document.querySelector(`[data-easy-popup-id="${id}"]`);

                        if(popup){
                            document.documentElement.classList.add('easy-popup-open');
                            document.documentElement.classList.add('ep-prevent-scroll');
                            popup.classList.add('open');
                        }
                    }, 100);
                }
            }

            if(e.target.closest('.ep-close-button') || e.target.classList.contains('easy-popup-overflow')){
                document.documentElement.classList.remove('easy-popup-open');
                document.documentElement.classList.remove('ep-prevent-scroll');
                document.querySelectorAll('.easy-popup').forEach(popup => popup.classList.remove('open'));
            }
        });
    });
})


/*********************************************
 * update price
 *********************************************/
window.addEventListener('click', () => {
    setTimeout(() => {
        document.querySelectorAll('.product-form-block[data-update-id="item-price"]').forEach((priceEle) => {
            const price = priceEle.querySelector('[data-price-text]').innerText;
            const customPriceEle = document.querySelector('.sp-product-info-mobile .sp-product-info-mobile__price-review [data-price-text]');
            if(customPriceEle){
                customPriceEle.innerText = price;
            }
        });
    }, 500);


})


/*********************************************
 * Update select
 *********************************************/
window.addEventListener('load', () => {
    const quantity = document.querySelector('[data-update-id="item-quantity"] ');
    if(!quantity) return;

    const buttons = document.querySelector('.paymentButtonsWrapper.btn-wrapper-default');
    if(!buttons) return;
    const button = buttons.querySelector('[data-update-id="submit-buy_buttons"]');
    if(!button) return;

    buttons.insertBefore(quantity, button);
})


/*********************************************
 * What's app
 *********************************************/
function onElementAppear(selector, callback) {
    const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                document.querySelectorAll(selector).forEach((element) => {
                    if (!element.__processed) { // Avoid repeated processing
                        element.__processed = true;
                        callback(element);
                    }
                });
            }
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
}

function onChildElementsAppear(wrapper, buttonSelector, textSelector, callback) {
    const observer = new MutationObserver(() => {
        const button = wrapper.querySelector(buttonSelector);
        const text = wrapper.querySelector(textSelector);

        if (button && text) {
            observer.disconnect(); // Stop observing once both elements are found
            callback(button, text);
        }
    });

    observer.observe(wrapper, { childList: true, subtree: true });
}

// Main function to detect when .spWhatsShare-container appears
onElementAppear('.spWhatsShare-container', (wrapper) => {
    onChildElementsAppear(wrapper, '.spk-wsp-chat-btn.chat-btn-on-img', '.spk-wsp-nft-text', (button, text) => {
        setTimeout(() => {
            const btnPositionRight = parseInt(button.style.right);
            const btnPositionBottom = parseInt(button.style.bottom);

            text.style.setProperty('--position-bottom', `${btnPositionBottom + 4}px`);
            text.style.setProperty('--position-right', `${btnPositionRight + 54 + 10}px`);
        }, 100);
    });
});

window.addEventListener('load', () => {
    onElementAppear('.posted-successfully', (wrapper) => {
        window.scrollTo({
            top: wrapper.getBoundingClientRect().top + window.pageYOffset - 165,
            behavior: 'smooth'
        });
    });
})

window.addEventListener('load', () => {
    function wrapSelects() {
        document.querySelectorAll('.product-form-block .wcpa_form_outer .wcpa_field_wrap > select').forEach(select => {
            if (!select.parentElement.classList.contains('select-wrap')) {
                const wrap = document.createElement('div');
                wrap.className = 'select-wrap';
                select.parentNode.insertBefore(wrap, select);
                wrap.appendChild(select);
            }
        });
    }

    const start = Date.now();
    const checkSelect = setInterval(() => {
        const selects = document.querySelectorAll('.product-form-block .wcpa_form_outer .wcpa_field_wrap > select');

        if (selects.length > 0) {
            wrapSelects();
            clearInterval(checkSelect);
        } else if (Date.now() - start >= 10000) {
            clearInterval(checkSelect);
        }
    }, 200);

    // Re-wrap if WCPA re-renders its fields (e.g. after variant change)
    const observer = new MutationObserver(wrapSelects);
    const formBlock = document.querySelector('.product-form-block');
    if (formBlock) observer.observe(formBlock, { childList: true, subtree: true });
});

// update discount in cart page
document.querySelectorAll('body.template-cart form.cart .grid.cart__row .grid__item.text-right').forEach(wrapper => {
    const discount = wrapper.querySelector('.cart--order-discount-wrapper');

    if (!discount) return;

    const group = document.createElement('div');
    group.className = 'group-discount';

    // Move the first 3 child elements into the group
    for (let i = 0; i < 3; i++) {
        const el = wrapper.children[0];
        group.appendChild(el);
    }

    // Insert the group at the top
    wrapper.insertBefore(group, wrapper.firstChild);
});

// click to accordion to close another
function closeOtherTabs(currentTab) {
    if (currentTab.closest('[data-wetheme-section-type="template--product"]')) return; // product info tabs stay open independently
    // scope: the whole FAQ/accordion section (adjust selector if you want narrower)
    const scope =
        currentTab.closest('section[data-wetheme-section-type="accordion--faq"]') ||
        currentTab.closest('section') ||
        document;

    scope.querySelectorAll('.collapsible-tab.open').forEach(tab => {
        if (tab === currentTab) return;

        tab.classList.remove('open');
        const content = tab.querySelector('.collapsible-content');
        if (content) {
            content.style.height = '0px';
            content.style.overflow = 'hidden';
        }
    });
}

// Click
document.addEventListener('click', (e) => {
    const btn = e.target.closest('collapsible-button');
    if (!btn) return;

    const currentTab = btn.closest('.collapsible-tab');
    if (!currentTab) return;

    keepTabInPlace(btn, () => closeOtherTabs(currentTab));
});

// Keep the clicked header at the same viewport position while other tabs collapse above it
function keepTabInPlace(btn, action) {
    if (btn.closest('[data-wetheme-section-type="template--product"]')) return action(); // no scroll compensation needed, avoids per-frame scrolling on iOS
    const startTop = btn.getBoundingClientRect().top;
    action();

    const startTime = performance.now();
    const DURATION = 700; // covers the height transition
    const step = () => {
        const delta = btn.getBoundingClientRect().top - startTop;
        if (Math.abs(delta) > 0.5) window.scrollBy(0, delta);
        if (performance.now() - startTime < DURATION) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
}

// Keyboard (Enter)
document.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;
    const btn = e.target.closest?.('collapsible-button');
    if (!btn) return;

    const currentTab = btn.closest('.collapsible-tab');
    if (!currentTab) return;

    keepTabInPlace(btn, () => closeOtherTabs(currentTab));
});


/**
 * Read more content v1.0.4
 * https://developer.mozilla.org/en-US/docs/Web/API/ResizeObserver
 * @param selector
 * @param maxHeight
 */
const readMore = ({selector, maxHeight = 200} = {}) => {
    const DURATION = 450;
    const toggle = (data, isCollapsed, animate = true) => {
        const content = data.content;
        clearTimeout(data.timer);

        if(isCollapsed){
            // close
            if(animate){
                const start = content.offsetHeight;
                content.style.transition = 'none';
                content.style.height = `${start}px`;
                content.style.overflow = 'hidden';
                content.offsetHeight; // force reflow so the transition starts from the current height
                content.style.transition = `height ${DURATION}ms ease`;
            }
            content.style.overflow = 'hidden';
            content.style.height = `${maxHeight}px`;
            if(data.button.hide) data.button.hide.style.display = 'none';
            data.button.show.style.display = '';
            data.wrapper.classList.add('collapsed');
        }else{
            // open
            const start = content.offsetHeight;
            content.style.transition = 'none';
            content.style.height = '';
            const target = content.offsetHeight; // natural height, scrollHeight would include trailing margins
            content.style.height = `${start}px`;
            content.style.overflow = 'hidden';
            content.offsetHeight; // force reflow so the transition starts from the current height
            content.style.transition = `height ${DURATION}ms ease`;
            content.style.height = `${target}px`;
            if(data.button.hide) data.button.hide.style.display = '';
            data.button.show.style.display = 'none';
            data.wrapper.classList.remove('collapsed');

            // remove inline CSS for responsive
            data.timer = setTimeout(() => {
                content.style.height = ``;
                content.style.transition = ``;
                content.style.overflow = ``;
            }, DURATION);
        }

        // resize if is inside a Flickity slider
        if(typeof Flickity !== 'undefined'){
            const flickitySlider = Flickity.data(data.wrapper.closest('.flickity-enabled'));
            if(flickitySlider) flickitySlider.resize();
        }
    }
    const setupReadMore = wrapper => {
        const data = {wrapper};

        // validate
        data.content = wrapper.querySelector('[data-read-more-content]');
        data.height = data.content.offsetHeight;
        data.content.style.height = ``;
        data.button = {
            show: wrapper.querySelector('[data-read-more-show]'),
            hide: wrapper.querySelector('[data-read-more-hide]'),
            wrapper: wrapper.querySelector('[data-read-more-buttons]'),
        };
        if(data.height <= maxHeight){
            data.button.wrapper.style.display = 'none';
            return;
        }

        // update class
        wrapper.classList.add('has-read-more');

        // setup CSS
        data.content.style.overflow = `hidden`;

        // assign button events
        data.button.show.addEventListener('click', () => toggle(data, false));
        if(data.button.hide) data.button.hide.addEventListener('click', () => toggle(data, true));

        // close on init
        toggle(data, true, false);
    }

    // init
    setupReadMore(selector);
}
document.querySelectorAll("[data-read-more]").forEach(wrapper => {
    const content = wrapper.querySelector(":scope > div");
    if (!content) return;

    content.setAttribute('data-read-more-content', '');
    const button = document.createElement("button");
    button.innerHTML = "+";
    button.setAttribute("data-read-more-show", '');
    const buttonReadMore = document.createElement("div");
    buttonReadMore.setAttribute("data-read-more-buttons", '');
    buttonReadMore.appendChild(button);
    wrapper.appendChild(buttonReadMore);

    readMore({selector: wrapper, maxHeight: 200});
})

/*********************************************
 * Size calculator
 *********************************************/
const spCalcLegShift = {short: -2, average: 0, long: 2};

/* Fixed body-size rules supplied by Kim; keep the visible size chart in sync. */
function spCalcReadChart(){
    // Kim's latest body measurements, in centimetres.
    return [
        {size:'XS', uk:'6–8', waist:[58,72], hip:[86,94]},
        {size:'S', uk:'10–12', waist:[72,80], hip:[95,104]},
        {size:'M', uk:'14–16', waist:[80,88], hip:[105,114]},
        {size:'L', uk:'18–20', waist:[88,96], hip:[115,120]},
        {size:'XL', uk:'20–22', waist:[96,112], hip:[121,127]}
    ];
}

/* Inclusive upper bounds; hip-limit size-up is handled in spCalcRecommend. */
function spCalcBand(rows, key, value){
    if(!Number.isFinite(value) || value < rows[0][key][0]) return -1;
    for(let i = 0; i < rows.length; i++){
        if(value <= rows[i][key][1]) return i;
    }
    return rows.length;
}

/* Uses Kim's height table; null means 31 inches may be too short. */
function spCalcLength(height, leg){
    const column = {short:1, average:2, long:3}[leg];
    if(!Number.isFinite(height) || height <= 0 || !column) return null;
    if(height >= 177.8) return null;
    if(height <= 142.2) return 25;
    const rows = [
        [142.2,25,25,25],
        [144.8,25,25,27], [147.3,25,25,27], [149.9,25,27,27],
        [152.4,27,27,27], [154.9,27,27,29], [157.5,27,29,29],
        [160.0,27,29,29], [162.6,29,29,31], [165.1,29,31,31],
        [167.6,29,31,31], [170.2,29,31,31], [172.7,29,31,31],
        [175.3,31,31,31]
    ];
    // Between listed heights, use the nearest row. Ties use the taller row.
    const row = rows.reduce((best, current) =>
        Math.abs(current[0]-height) <= Math.abs(best[0]-height) ? current : best);
    return row[column];
}

/* Opens or closes the calculator accordion */
function spCalcToggle(calc, open){
    calc.classList.toggle('is-open', open);
    calc.querySelector('[data-size-calc-toggle]').setAttribute('aria-expanded', open);
    calc.querySelector('.sp-size-calc__panel').inert = !open;
}

/* Shows a message in the result area, or hides the area when no message is given */
function spCalcShow(calc, html){
    const result = calc.querySelector('[data-size-calc-result]');
    if(html) result.querySelector('.sp-size-calc__result-text').innerHTML = html;
    result.classList.toggle('is-show', !!html);
}

/* Clicks the size swatch matching the recommended size, returns 'sold-out' or 'missing' when it cannot be selected */
function spCalcSelectSize(calc, size){
    const optionName = calc.dataset.sizeOption.toLowerCase();
    const matcher = new RegExp(`(^|[\\s/])${size}$`, 'i');
    const swatch = [...document.querySelectorAll('.swatch-element')].find(el => (el.dataset.option || '').toLowerCase() === optionName && matcher.test((el.dataset.value || '').trim()));

    if(!swatch) return 'missing';
    if(swatch.classList.contains('soldout')) return 'sold-out';

    const input = swatch.querySelector('input');
    if(input && !input.checked) swatch.querySelector('label').click();
    return 'ok';
}

/* Sets the length dropdown of the product options app to the recommended inseam */
function spCalcSelectLength(length){
    document.querySelectorAll('select.wcpa_field').forEach(select => {
        const option = [...select.options].find(opt => new RegExp(`\\b${length}\\s*["”]`).test(opt.text));
        if(!option) return;

        select.value = option.value;
        select.dispatchEvent(new Event('change', {bubbles: true}));
    });
}

/* Works out the size and inseam from the form and shows the recommendation */
function spCalcRecommend(calc, chart){
    if(!spCalcValidate(calc)) return;
    const route = calc.querySelector('[data-size-calc-tab][aria-selected="true"]').dataset.sizeCalcTab;
    const leg = calc.querySelector('[data-size-calc-leg][aria-pressed="true"]').dataset.sizeCalcLeg;
    const value = id => spCalcMeasurement(calc.querySelector(id), calc);
    const last = chart.length - 1;
    const height = value(route === 'tape' ? '#sp-calc-height' : '#sp-calc-height-2');
    let sizeIndex;
    let fitNote = '';
    if(!Number.isFinite(height) || height < 100 || height > 230){
        return spCalcShow(calc, 'Please enter a valid height, such as 160 in centimetres or 5ft2 in the inches tab (100–230 cm).');
    }
    if(route === 'tape'){
        const hip = value('#sp-calc-hip');
        const waist = value('#sp-calc-waist');
        const hipIndex = spCalcBand(chart, 'hip', hip);
        const waistIndex = spCalcBand(chart, 'waist', waist);
        if(hipIndex < 0 || hipIndex > last || waistIndex < 0 || waistIndex > last){
            return spCalcShow(calc, 'This guide covers hips 86–127 cm and waist 58–112 cm. Please check your measurements or contact us for fit advice.');
        }
        sizeIndex = hipIndex;
        if(hip === chart[hipIndex].hip[1]){
            if(hipIndex === last){
                return spCalcShow(calc, 'Your hips are at the upper limit of XL. We would normally suggest sizing up, but no larger size is listed. Please contact us for fit advice.');
            }
            sizeIndex++;
            fitNote += `<br><br>Your hips are at the upper limit of ${chart[hipIndex].size}, so we suggest sizing up for more room.`;
        }
        if(waistIndex > sizeIndex){
            sizeIndex = waistIndex;
            fitNote += `<br><br>Your waist points to ${chart[sizeIndex].size}. This size may feel roomier through the hips.`;
        }
    }else{
        sizeIndex = chart.findIndex(item => item.size === calc.querySelector('#sp-calc-uk').value);
        if(sizeIndex < 0) return spCalcShow(calc, 'Please choose your usual UK trouser size.');
    }
    const size = chart[sizeIndex].size;
    const length = spCalcLength(height, leg);
    if(length === null){
        return spCalcShow(calc, `<strong>Suggested size: ${size}.</strong><br>31&quot; may be too short for your height and leg proportions. Please contact us before choosing a length.${fitNote}`);
    }
    const status = spCalcSelectSize(calc, size);
    const soldOutNote = status === 'sold-out' ? `<br><br>${size} is currently sold out in this colour.` : '';
    const lengthNote = length === 25 ? '<br><br>25&quot; is custom shortened. Please check the custom-length price and return terms before ordering.' : '';
    if(status !== 'missing') spCalcSelectLength(length);
    spCalcShow(calc, `<strong>We suggest ${size} with a ${length}&quot; inseam.</strong><br>Length is estimated from your height and leg proportions. Compare with a pair that fits you well.${fitNote}${soldOutNote}${lengthNote}`);
}

/* Fills the usual UK size dropdown from the chart, or hides the calculator when the chart is missing */
function spCalcInit(){
    const calc = document.querySelector('[data-size-calc]');
    if(!calc) return;

    const chart = spCalcReadChart();
    if(!chart.length){
        calc.hidden = true;
        return;
    }

    calc.querySelector('#sp-calc-uk').insertAdjacentHTML('beforeend', chart.map(item => `<option value="${item.size}">UK ${item.uk}</option>`).join(''));
    calc.chart = chart;
}

spCalcInit();

document.addEventListener('click', (e) => {
    const calc = e.target.closest('[data-size-calc]');
    if(!calc) return;

    if(e.target.closest('[data-size-calc-toggle]')){
        spCalcToggle(calc, !calc.classList.contains('is-open'));
    }

    const tab = e.target.closest('[data-size-calc-tab]');
    if(tab){
        calc.querySelectorAll('[data-size-calc-tab]').forEach(el => el.setAttribute('aria-selected', el === tab));
        calc.querySelectorAll('[data-size-calc-route]').forEach(el => el.hidden = el.dataset.sizeCalcRoute !== tab.dataset.sizeCalcTab);
        spCalcShow(calc, '');
    }

    const legBtn = e.target.closest('[data-size-calc-leg]');
    if(legBtn){
        calc.querySelectorAll('[data-size-calc-leg]').forEach(el => el.setAttribute('aria-pressed', el === legBtn));
        spCalcShow(calc, '');
    }

    if(e.target.closest('[data-size-calc-submit]') && calc.chart) spCalcRecommend(calc, calc.chart);
});

document.addEventListener('input', (e) => {
    const calc = e.target.closest('[data-size-calc]');
    if(calc) spCalcShow(calc, '');
});

document.addEventListener('keydown', (e) => {
    const calc = e.target.closest('[data-size-calc]');
    if(calc && calc.chart && e.key === 'Enter' && e.target.matches('input')){
        e.preventDefault();
        spCalcRecommend(calc, calc.chart);
    }
});

/* Unit switcher: all calculations continue to use centimetres internally. */
function spCalcMeasurement(input, calc){
    if(input.value.trim() === '') return NaN;
    if(input.dataset.spShown === input.value && input.dataset.spCm !== undefined){
        return Number(input.dataset.spCm);
    }
    if(calc.dataset.measureUnit === 'in' && input.dataset.spHeight === 'true'){
        const match = input.value.trim().toLowerCase().match(/^(\d+)\s*(?:ft|feet|'|′)\s*(?:(\d+(?:\.\d+)?)\s*(?:in|inches|"|″)?)?$/);
        if(!match || Number(match[2] || 0) >= 12) return NaN;
        return (Number(match[1]) * 12 + Number(match[2] || 0)) * 2.54;
    }
    return Number(input.value) * (calc.dataset.measureUnit === 'in' ? 2.54 : 1);
}

function spCalcFeetText(cm){
    const total = Math.round(cm / 2.54 * 100) / 100;
    const feet = Math.floor(total / 12);
    return feet + 'ft' + Number((total - feet * 12).toFixed(2));
}

function spCalcSetUnit(calc, unit){
    const inputs = [...calc.querySelectorAll('input[data-sp-label]')];
    const measurements = inputs.map(input => spCalcMeasurement(input, calc));
    calc.dataset.measureUnit = unit;
    inputs.forEach((input, index) => {
        const cm = measurements[index];
        const factor = unit === 'in' ? 2.54 : 1;
        const feetHeight = unit === 'in' && input.dataset.spHeight === 'true';
        input.type = feetHeight ? 'text' : 'number';
        input.inputMode = feetHeight ? 'text' : 'decimal';
        if(Number.isFinite(cm)){
            input.value = feetHeight ? spCalcFeetText(cm) : String(Number((cm / factor).toFixed(2)));
            input.dataset.spCm = String(cm);
            input.dataset.spShown = input.value;
        }
        input.step = 'any';
        input.min = String(Number(input.dataset.spMin) / factor);
        input.max = String(Number(input.dataset.spMax) / factor);
        const example = Number(input.dataset.spExample) / factor;
        input.placeholder = feetHeight ? 'Example: 5ft2' : 'Example: ' + Number(example.toFixed(1));
        const field = input.closest('.sp-size-calc__field');
        const suffix = field && field.querySelector('.sp-size-calc__unit');
        if(suffix) suffix.textContent = feetHeight ? 'ft / in' : unit;
        const label = field && field.querySelector('label');
        if(label) label.textContent = input.dataset.spLabel + ' (' + (feetHeight ? 'ft / in' : unit) + ')';
    });
    calc.querySelectorAll('[data-sp-unit]').forEach(button => {
        button.setAttribute('aria-pressed', String(button.dataset.spUnit === unit));
    });
    spCalcShow(calc, '');
}

function spCalcInitUnits(){
    document.querySelectorAll('[data-size-calc]').forEach(calc => {
        if(calc.querySelector('[data-sp-unit]')) return;
        const tabs = calc.querySelector('.sp-size-calc__tabs');
        if(!tabs) return;
        calc.querySelectorAll('input[type="number"]').forEach(input => {
            input.dataset.spMin = input.min || '0';
            input.dataset.spMax = input.max || '300';
            input.dataset.spExample = (input.placeholder.match(/\d+(?:\.\d+)?/) || ['160'])[0];
            input.dataset.spHeight = String(input.id.includes('height'));
            const label = input.closest('.sp-size-calc__field').querySelector('label');
            input.dataset.spLabel = label ? label.textContent : 'Measurement';
        });
        const wrapper = document.createElement('div');
        wrapper.className = 'sp-size-calc__unit-switch';
        wrapper.innerHTML = '<div class="sp-size-calc__unit-buttons" role="group" aria-label="Measurement units"><button type="button" data-sp-unit="cm" aria-pressed="true">Centimetres (cm)</button><button type="button" data-sp-unit="in" aria-pressed="false">Inches (in)</button></div>';
        tabs.before(wrapper);
        const lead = calc.querySelector('.sp-size-calc__lead');
        if(lead) lead.hidden = true;
        spCalcSetUnit(calc, 'cm');
    });
}

if(!document.getElementById('sp-measure-unit-style')){
    const style = document.createElement('style');
    style.id = 'sp-measure-unit-style';
    style.textContent = `
    .sp-size-calc .sp-size-calc__unit-buttons{display:flex;gap:4px;background:#dcebea;border:1px solid #b6cdca;padding:4px;border-radius:8px;margin:16px 0 20px}
    .sp-size-calc .sp-size-calc__unit-buttons button{flex:1;min-width:0;min-height:44px;padding:10px 6px;border:0;border-radius:5px;background:transparent;color:#254b48;font:inherit;font-size:14px;cursor:pointer;letter-spacing:normal;text-transform:none}
    .sp-size-calc .sp-size-calc__unit-buttons button[aria-pressed="true"]{background:#234c48;color:#fff;font-weight:600}
    .sp-size-calc .sp-size-calc__unit-buttons button:focus-visible{outline:2px solid #a1352e;outline-offset:2px}
    .sp-size-calc .sp-size-calc__lead[hidden]{display:none!important}
    .sp-size-calc [data-size-calc-tab]{font-weight:400}
    .sp-size-calc [data-size-calc-tab][aria-selected="true"]{font-weight:700!important}
    `;
    document.head.appendChild(style);
}
document.addEventListener('click', event => {
    const button = event.target.closest('[data-sp-unit]');
    if(!button) return;
    const calc = button.closest('[data-size-calc]');
    if(calc && calc.dataset.measureUnit !== button.dataset.spUnit){
        spCalcSetUnit(calc, button.dataset.spUnit);
    }
});
if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', spCalcInitUnits);
else spCalcInitUnits();
document.addEventListener('shopify:section:load', spCalcInitUnits);

/* Field-level errors, scoped to the size calculator. */
function spCalcClearFieldError(input){
    input.removeAttribute('aria-invalid');
    const errorId = input.dataset.spErrorId;
    if(!errorId) return;
    const error = document.getElementById(errorId);
    if(error) error.remove();
    const descriptions = (input.getAttribute('aria-describedby') || '').split(' ').filter(id => id && id !== errorId);
    if(descriptions.length) input.setAttribute('aria-describedby', descriptions.join(' '));
    else input.removeAttribute('aria-describedby');
}
function spCalcFieldError(input, message){
    spCalcClearFieldError(input);
    input.setAttribute('aria-invalid', 'true');
    if(!input.dataset.spErrorId) input.dataset.spErrorId = 'sp-fit-error-' + (++spCalcErrorCounter);
    const error = document.createElement('p');
    error.id = input.dataset.spErrorId;
    error.className = 'sp-size-calc__field-error';
    error.textContent = message;
    input.closest('.sp-size-calc__field').appendChild(error);
    input.setAttribute('aria-describedby', ((input.getAttribute('aria-describedby') || '') + ' ' + error.id).trim());
}
var spCalcErrorCounter = 0;
function spCalcValidate(calc){
    calc.querySelectorAll('[aria-invalid="true"]').forEach(spCalcClearFieldError);
    const route = calc.querySelector('[data-size-calc-tab][aria-selected="true"]').dataset.sizeCalcTab;
    const imperial = calc.dataset.measureUnit === 'in';
    let first = null;
    const fail = (input, message) => { spCalcFieldError(input, message); if(!first) first = input; };
    if(route === 'tape'){
        for(const [id, name, min, max] of [['#sp-calc-hip','hip',86,127], ['#sp-calc-waist','waist',58,112]]){
            const input = calc.querySelector(id);
            const cm = spCalcMeasurement(input, calc);
            if(!Number.isFinite(cm) || cm <= 0){
                fail(input, 'Enter your ' + name + ' measurement in ' + (imperial ? 'inches.' : 'centimetres.'));
            }else if(cm < min || cm > max){
                const range = imperial ? (min / 2.54).toFixed(2) + '–' + (max / 2.54).toFixed(2) + ' in (approximately)' : min + '–' + max + ' cm';
                fail(input, 'This guide covers ' + range + '. Check your entry, or contact us if your measurement is outside this range.');
            }
        }
    }else{
        const input = calc.querySelector('#sp-calc-uk');
        if(!input.value) fail(input, 'Please select your usual UK trouser size.');
    }
    const height = calc.querySelector(route === 'tape' ? '#sp-calc-height' : '#sp-calc-height-2');
    const cm = spCalcMeasurement(height, calc);
    if(!Number.isFinite(cm) || cm <= 0){
        fail(height, imperial ? 'Enter feet and inches, Example: 5ft2 for 5 feet 2 inches.' : 'Enter your height in centimetres, Example: 160.');
    }else if(cm < 100 || cm > 230){
        fail(height, imperial ? 'Please check your height. This guide covers 100–230 cm (about 3ft3–7ft6).' : 'Please check your height. This guide covers 100–230 cm.');
    }
    if(first){ spCalcShow(calc, ''); first.focus(); return false; }
    return true;
}
if(!document.getElementById('sp-fit-validation-style')){
    const style = document.createElement('style');
    style.id = 'sp-fit-validation-style';
    style.textContent = `
    .sp-size-calc input[aria-invalid="true"],.sp-size-calc select[aria-invalid="true"]{border:2px solid #a1352e!important;background:#fff7f6!important;outline-color:#a1352e}
    .sp-size-calc .sp-size-calc__field-error{color:#a1352e;font-size:13px;line-height:1.45;margin:7px 0 0}
    .sp-size-calc .sp-size-calc__field:has(.sp-size-calc__field-error) .sp-size-calc__unit{display:none}
    `;
    document.head.appendChild(style);
}
document.addEventListener('input', event => {
    if(event.target.closest('[data-size-calc]')) spCalcClearFieldError(event.target);
});
document.addEventListener('change', event => {
    if(event.target.closest('[data-size-calc]')) spCalcClearFieldError(event.target);
});
document.addEventListener('click', event => {
    if(!event.target.closest('[data-sp-unit], [data-size-calc-tab]')) return;
    const calc = event.target.closest('[data-size-calc]');
    if(calc) calc.querySelectorAll('[aria-invalid="true"]').forEach(spCalcClearFieldError);
});


/*********************************************
 * Petite length note
 *********************************************/
const spLengthNote = 'Custom 25" Inseam is non-refundable. Unsure? <a href="/pages/contact" target="_blank" rel="noopener">Message Kim for help.</a>';

/* Adds the petite note below the length dropdown of the product options app when it has a 25" option */
function spAddLengthNote(){
    document.querySelectorAll('select.wcpa_field').forEach(select => {
        const field = select.closest('.wcpa_field_wrap');
        if(!field || field.parentElement.querySelector('.sp-wcpa-note') || ![...select.options].some(opt => /\b25\s*["”]/.test(opt.text))) return;

        const note = document.createElement('p');
        note.className = 'sp-wcpa-note';
        note.innerHTML = spLengthNote;
        field.after(note);
    });
}

let spLengthNoteFrame = 0;
spAddLengthNote();
new MutationObserver(() => {
    cancelAnimationFrame(spLengthNoteFrame);
    spLengthNoteFrame = requestAnimationFrame(spAddLengthNote);
}).observe(document.body, {childList: true, subtree: true});

